import { GuestUpdateType, OrganizerUpdateType, PlaydateInvite } from "../../gql/types";
import { TagVariant } from "./InfoTag";

export const outboundTopLeftLabelComputer = (invite: PlaydateInvite): Array<{ label: string; variant: TagVariant }> => {
    const topLeftTags: Array<{ label: string; variant: TagVariant }> = [];

    if (invite.organizerUpdate) {
        switch (invite.organizerUpdate.updateType) {
            case OrganizerUpdateType.InviteCreated:
                topLeftTags.push({
                    label: "Waiting For Response",
                    variant: TagVariant.DEFAULT,
                });
                break;
            case OrganizerUpdateType.ResponseModified:
                topLeftTags.push({
                    label: "Response Changed",
                    variant: TagVariant.NOTICE,
                });
                break;
            case OrganizerUpdateType.ResponseReceived:
                topLeftTags.push({
                    label: "Response Received",
                    variant: TagVariant.STATE_REPRESENTATION,
                });
                break;
            case OrganizerUpdateType.InviteCreated:
            case OrganizerUpdateType.EnoughResponseReceived:
            case OrganizerUpdateType.GuestRejected:
            case OrganizerUpdateType.Finalized:
            case OrganizerUpdateType.InviteCancelled:
                break;

        }
    }

    return topLeftTags;
}